module.exports = __webpack_public_path__ + "static/media/croatia-flag.ee2a92a0.png";